var map = {
	"./": "fc7b",
	"./IRI": "a19d",
	"./IRI.js": "a19d",
	"./index": "fc7b",
	"./index.js": "fc7b",
	"./other": "ebea",
	"./other.js": "ebea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "02cd";